// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1322b2ca","455":"207ce889","977":"f4f29a47"}[chunkId] + ".chunk.js";
};